import { LuLanguages } from 'react-icons/lu';
import { useLang } from '../../context/langContext';
import { webStrings } from '../../i18n/web-strings';

/**
 * English ⇄ Telugu switch — port of `LangToggle` in `shared/widgets/lang_toggle.dart`. The label is
 * the language a click switches *to*, written in that language, so someone who cannot read the
 * current one can still find their own.
 *
 * `compact` shows `తె` / `EN` only (collapsed side nav, sign-in states).
 */
export default function LangToggle({ compact = false, className = '' }: { compact?: boolean; className?: string }) {
    const { isTelugu, toggle, tr } = useLang();
    return (
        <button
            type="button"
            onClick={toggle}
            title={tr(webStrings, 'language')}
            lang={isTelugu ? 'en' : 'te'}
            className={`flex items-center gap-2 font-semibold ${className}`}
        >
            {!compact && <LuLanguages size={17} className="shrink-0" />}
            <span className="truncate">{compact ? (isTelugu ? 'EN' : 'తె') : isTelugu ? 'English' : 'తెలుగు'}</span>
        </button>
    );
}
